import Button from "@mui/material/Button";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Chip from "@mui/material/Chip";
import Link from "@mui/material/Link";
import type { PublicationItemInfo } from "./useTaskDetailSubscription";
import type { PreviewSibling } from "./useTaskDetailActions";
import { IndexingBadge } from "../../ui/IndexingBadge";
import { IfPermission } from "../../auth/IfPermission";
import { PUBLICATION_ITEM_STATUS_COLORS } from "./ArticleVariations";
import type { VariationInfo } from "./ArticleVariations";

export function VariationPublicationRows(props: {
  variations: VariationInfo[];
  publicationItems: PublicationItemInfo[];
  onViewVariation: (variationId: string, siblings: PreviewSibling[]) => void;
}) {
  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell sx={{ color: "text.secondary", fontSize: 12 }}>#</TableCell>
          <TableCell sx={{ color: "text.secondary", fontSize: 12 }}>Сайт</TableCell>
          <TableCell sx={{ color: "text.secondary", fontSize: 12 }}>Статус</TableCell>
          <TableCell sx={{ color: "text.secondary", fontSize: 12 }}>URL публикации</TableCell>
          <TableCell align="center" sx={{ color: "text.secondary", fontSize: 12 }}>Индексация</TableCell>
          <TableCell sx={{ color: "text.secondary", fontSize: 12 }}>Превью</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {props.variations.map((value) => {
          const item = props.publicationItems.find((publicationItem) => publicationItem.variationId === value.id);
          return (
            <TableRow key={value.id}>
              <TableCell>#{value.index}</TableCell>
              <TableCell>{item ? item.siteUrl : "—"}</TableCell>
              <TableCell>
                {item ? (
                  <Chip
                    label={item.status}
                    size="small"
                    color={PUBLICATION_ITEM_STATUS_COLORS[item.status]}
                  />
                ) : (
                  "—"
                )}
              </TableCell>
              <TableCell>
                {item && item.publishedUrl ? (
                  <Link href={item.publishedUrl} target="_blank" rel="noopener noreferrer">
                    {item.publishedUrl}
                  </Link>
                ) : (
                  "—"
                )}
              </TableCell>
              <TableCell align="center">
                <IndexingBadge aggregate={item ? item.indexing : null} />
              </TableCell>
              <TableCell>
                <IfPermission permission="generation.view">
                  <Button
                    size="small"
                    variant="text"
                    onClick={() => props.onViewVariation(value.id, props.variations)}
                  >
                    Превью
                  </Button>
                </IfPermission>
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
}
